module.exports = __webpack_public_path__ + "img/qx6.0bdc0fca.png";